<template>
  <div
    role="dialog"
    ref="trap-container"
    tabindex="-1"
    :class="['side-pannel', { showing: show }]"
    :aria-label="label"
    :hidden="!show"
    :id="`${uuid}-container`"
  >
    <slot></slot>
  </div>
</template>

<script>
import KeyboardTrapMixin from '@/utils/mixins/keyboardTrapMixin.js';

export default {
  name: 'SidePanel',
  mixins: [KeyboardTrapMixin],
  props: {
    label: {
      type: String,
      required: true,
    },
    show: {
      default: () => false,
      type: Boolean,
      required: true,
    },
    // toggle to update keydown event listeners
    // useful for when modal re-renders or view updates
    resetListener: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      uuid: this.$pigeonline.createUUID(),
    };
  },
  created() {
    this.setInert = false;
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  watch: {
    resetListener: function () {
      this.resetKeydownListener();
    },
  },
};
</script>
